import { COLUMN_ID, FIELD_NAME, TABS } from './constants';
import { MappingDataValues } from '../../common/domain/mappingAdmin';

const dateFormatter = (params: any) =>
  params.value
    ? new Date(params.value).toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      }) + ' UTC'
    : '';

export const getFieldMappingColumns = (
  acceptedValues: MappingDataValues,
  groups: string[] = [],
) => [
  {
    field: COLUMN_ID.GROUP_ID,
    headerName: 'Group ID',
    cellEditor: 'agSelectCellEditor',
    cellEditorParams: {
      values: [...(groups ?? [])].sort(),
    },
  },
  {
    field: COLUMN_ID.FIELD_NAME,
    headerName: 'Field Name',
    cellEditor: 'agSelectCellEditor',
    cellEditorParams: {
      values: [FIELD_NAME.DAY_COUNT, FIELD_NAME.PAY_FREQUENCY],
    },
  },
  {
    field: COLUMN_ID.INPUT_VALUE,
    headerName: 'Input Value',
  },
  {
    field: COLUMN_ID.MAPPED_VALUE,
    headerName: 'Mapped Value',
    cellEditor: 'agSelectCellEditor',
    cellEditorParams: (params: any) => {
      const fieldName = params.data?.fieldName;
      const values =
        fieldName && acceptedValues[fieldName]
          ? acceptedValues[fieldName]
          : [
              ...(acceptedValues[FIELD_NAME.DAY_COUNT] ?? []),
              ...(acceptedValues[FIELD_NAME.PAY_FREQUENCY] ?? []),
            ];
      return { values: Array.from(new Set(values)).sort() };
    },
  },
  {
    field: COLUMN_ID.VALID_FROM,
    headerName: 'Valid From',
    valueFormatter: dateFormatter,
  },
  {
    field: COLUMN_ID.VALID_TO,
    headerName: 'Valid To',
    valueFormatter: dateFormatter,
  },
  {
    field: COLUMN_ID.LAST_UPDATED_BY,
    headerName: 'Last Updated By',
    editable: false,
  },
  {
    field: COLUMN_ID.LAST_UPDATE_TIMESTAMP,
    headerName: 'Last Update Time',
    editable: false,
    valueFormatter: dateFormatter,
  },
];

export const getFixingProxyMappingColumns = (
  acceptedValues: MappingDataValues,
  groups: string[] = [],
) => [
  {
    field: COLUMN_ID.GROUP_ID,
    headerName: 'Group ID',
    cellEditor: 'agSelectCellEditor',
    cellEditorParams: {
      values: [...(groups ?? [])].sort(),
    },
  },
  {
    field: COLUMN_ID.INPUT_REFERENCE_INDEX,
    headerName: 'Input Reference Index',
  },
  {
    field: COLUMN_ID.MAPPED_REFERENCE_INDEX,
    headerName: 'Mapped Reference Index',
    cellEditor: 'agSelectCellEditor',
    cellEditorParams: {
      values: [...(acceptedValues[FIELD_NAME.REFERENCE_INDEX] ?? [])].sort(),
    },
  },
  {
    field: COLUMN_ID.MAPPED_PAY_FREQUENCY,
    headerName: 'Mapped Pay Frequency',
    cellEditor: 'agSelectCellEditor',
    cellEditorParams: {
      values: [...(acceptedValues[FIELD_NAME.PAY_FREQUENCY] ?? [])].sort(),
    },
  },
  {
    field: COLUMN_ID.MAPPED_DAY_COUNT,
    headerName: 'Mapped Day Count',
    cellEditor: 'agSelectCellEditor',
    cellEditorParams: {
      values: [...(acceptedValues[FIELD_NAME.DAY_COUNT] ?? [])].sort(),
    },
  },
  {
    field: COLUMN_ID.VALID_FROM,
    headerName: 'Valid From',
    valueFormatter: dateFormatter,
  },
  {
    field: COLUMN_ID.VALID_TO,
    headerName: 'Valid To',
    valueFormatter: dateFormatter,
  },
  {
    field: COLUMN_ID.LAST_UPDATED_BY,
    headerName: 'Last Updated By',
    editable: false,
  },
  {
    field: COLUMN_ID.LAST_UPDATE_TIMESTAMP,
    headerName: 'Last Update Time',
    editable: false,
    valueFormatter: dateFormatter,
  },
];

export const getLegalEntityMappingColumns = (groups: string[] = []) => [
  {
    field: COLUMN_ID.LEGAL_ENTITY,
    headerName: 'Legal Entity',
  },
  {
    field: COLUMN_ID.MAPPED_GROUP_ID,
    headerName: 'Mapped Group ID',
    cellEditor: 'agSelectCellEditor',
    cellEditorParams: {
      values: [...(groups ?? [])].sort(),
    },
  },
  {
    field: COLUMN_ID.VALID_FROM,
    headerName: 'Valid From',
    valueFormatter: dateFormatter,
  },
  {
    field: COLUMN_ID.VALID_TO,
    headerName: 'Valid To',
    valueFormatter: dateFormatter,
  },
  {
    field: COLUMN_ID.LAST_UPDATED_BY,
    headerName: 'Last Updated By',
    editable: false,
  },
  {
    field: COLUMN_ID.LAST_UPDATE_TIMESTAMP,
    headerName: 'Last Update Time',
    editable: false,
    valueFormatter: dateFormatter,
  },
];

export const getTabColumns = (
  acceptedValues: MappingDataValues,
  groups: string[] = [],
) => ({
  [TABS.RATES_FIELD]: () => getFieldMappingColumns(acceptedValues, groups),
  [TABS.RATES_FIXING]: () =>
    getFixingProxyMappingColumns(acceptedValues, groups),
  [TABS.LEGAL_ENTITY]: () => getLegalEntityMappingColumns(groups),
});
